import React from "react";
import API from "../../utilities/LocalApiProxy";
import { openGlobalDialog } from "../globalEditDialogActions";
import { MULTIPLE_FILE_UPLOAD_CANCELED } from "../types";
import { ocrOnDemandAllowed } from "../../utilities/utilities";
import { bulkUploadMultipleFiles } from "./index";

export function countPDFFiles(files) {
	let numPdfs = 0;
	for (let f = 0; f < files.length; f++) {
		if (ocrOnDemandAllowed(files[f].name)) {
			numPdfs++;
		}
	}
	return numPdfs;
}

export async function checkOCRLimits({
	numPdfs,
	files,
	matterID,
	basepath,
	directoryID,
	autoRename,
	callback,
	dispatch,
}) {
	if (numPdfs === 0) {
		return true; // no PDFs, no need to check
	}

	let ignoreOverOcrLimitWarning = window.localStorage.getItem(
		"ignoreOverOcrLimitWarning"
	);
	let showWarningDialog = true;

	if (ignoreOverOcrLimitWarning) {
		// has a value other than null
		let date = new Date();
		let startOfNextMonth = new Date(
			Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1)
		);
		let ignoreWarningDate = new Date(ignoreOverOcrLimitWarning);
		if (ignoreWarningDate < startOfNextMonth) {
			showWarningDialog = false;
		} else {
			// should I delete the old one?
			window.localStorage.removeItem("ignoreOverOcrLimitWarning");
		}
	}

	if (!showWarningDialog) {
		return true;
	}

	try {
		const ocrLimitsRes = await API.get("/ocr/limits");
		let {
			mysql: { tenantLimits, tenantUsage, tenantFeatures },
		} = ocrLimitsRes;
		let OCR_TRANSACTIONS_THIS_MONTH =
			tenantUsage.OCR_TRANSACTIONS_THIS_MONTH;
		let ocrLimitThisMonth = tenantLimits.OCR_PER_MONTH_NET;
		let ocrIsEnabled = tenantFeatures.automaticOCR === 1;

		if (
			OCR_TRANSACTIONS_THIS_MONTH + numPdfs > ocrLimitThisMonth &&
			ocrIsEnabled
		) {
			// warn the user that all of their pdfs may not be OCR'd
			let label = "OCR Credit Warning";
			let message;
			let submitButtonLabel;

			if (OCR_TRANSACTIONS_THIS_MONTH >= ocrLimitThisMonth) {
				message = `You are uploading ${numPdfs} PDF file(s). They will not be OCR'd because your organization is out of OCR credits for the month. Please contact your firm administrator to authorize additional credits for the month.`;
				submitButtonLabel = "Upload Without OCR";
			} else {
				message = `You are uploading ${numPdfs} PDF file(s). Some of them may not be OCR'd because your organization is nearly out of OCR credits for the month. Please contact your firm administrator to authorize additional credits for the month.`;
				submitButtonLabel = "Upload Anyway";
			}

			openGlobalDialog(
				{
					label,
					mainText: <div>{message}</div>,
					type: "ocrLimitWarning", // this will populate the checkbox to ignore the warning for the rest of the month
					canSubmit: true,
					hideTextfield: true,
					submitButtonLabel,
				},
				() =>
					//call again with userIgnoredTheLimit true
					bulkUploadMultipleFiles({
						matterID,
						basepath,
						directoryID,
						files,
						autoRename,
						callback,
						userIgnoredTheLimit: true,
					})(dispatch),
				() => ({ canSubmit: true }),
				() => {
					dispatch({
						type: MULTIPLE_FILE_UPLOAD_CANCELED,
					});
				}
			)(dispatch);

			dispatch({
				type: MULTIPLE_FILE_UPLOAD_CANCELED,
			});
			return false;
		}
	} catch (e) {
		console.log(
			"unable to determine if we should warn user about OCR limit",
			e
		);
	}

	return true;
}
